import script from "./DeskopMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DeskopMenu.vue?vue&type=script&setup=true&lang=js"

import "./DeskopMenu.vue?vue&type=style&index=0&id=407b2f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407b2f6a"]])

export default __exports__